import { useAuth } from 'contexts/auth'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

function isCertificateExpiringSoon(
  dateStr: string | null | undefined,
  daysThreshold: number = 30
): boolean {
  if (!dateStr || dateStr === 'Invalid Date') return false

  const [day, month, year] = dateStr.split('/').map(Number)
  const certificateDate = new Date(year, month - 1, day)
  certificateDate.setHours(0, 0, 0, 0)

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const diffInDays = (certificateDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)

  return diffInDays <= daysThreshold
}

const useRedirects = () => {
  const { user } = useAuth()
  const history = useHistory()

  useEffect(() => {
    if (!user) {
      return history.push('/')
    }

    if (user.isAdmin) {
      return history.push('/dashboard')
    }

    if (!user.emailIsConfirmed) {
      return history.push('/verify-email')
    }

    if (user.organization === null) {
      return history.push('/select-organization')
    }

    if (
      user.isSeller &&
      user.organization &&
      !user.organization.hasAgreedToTermsAndConditions &&
      !user.hasAgreedToTermsAndConditions
    ) {
      return history.push('/terms-and-conditions')
    }

    // Buyers without a valid eSocial connection (certificate or procuração)
    // must go through /datasource-connect first.
    if (
      !user.isSeller &&
      !user.skipUpload &&
      (!user.organization?.uploadedCertificate ||
       !user.organization?.certificateValidate ||
       user.organization?.certificateValidate === 'Invalid Date' ||
       isCertificateExpiringSoon(user.organization?.certificateValidate)
      )
    ) {
      return history.push('/datasource-connect')
    }

    // Once connected, buyers still need to select which eSocial tables to share.
    if (
      user.organization?.uploadedCertificate &&
      !user.hasPermissionRequest &&
      !user.skipUpload
    ) {
      return history.push('/request-permission')
    }

    return history.push('/dashboard')
  }, [user])
}

export default useRedirects
